import { render, staticRenderFns } from "./entruckListV4.vue?vue&type=template&id=22df5998&scoped=true&"
import script from "./entruckListV4.vue?vue&type=script&lang=js&"
export * from "./entruckListV4.vue?vue&type=script&lang=js&"
import style0 from "./entruckListV4.vue?vue&type=style&index=0&id=22df5998&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df5998",
  null
  
)

export default component.exports